'use strict'

import Utils from './../common/utils'

export default class Leak {
    // constructor() {

    // }

    static fromData(data) {
        if (!data) {
            return null
        }
        
        let leak = new Leak()
        leak._id = Utils.isNumber(data.id_leak) ? Number(data.id_leak) : -1
        leak._btwn = Leak.validateValue(data.btwn, null)
        leak._id_section_1 = Leak.validateValue(data.section_1_id, null)
        leak._name_section_1 = Leak.validateValue(data.section_1_name, null)
        leak._id_site_1 = Leak.validateValue(data.site_1_id, -1)
        leak._name_site_1 = Leak.validateValue(data.site_1_name, null)
        leak._id_section_2 = Leak.validateValue(data.section_2_id, null)
        leak._name_section_2 = Leak.validateValue(data.section_2_name, null)
        leak._id_site_2 = Leak.validateValue(data.site_2_id, null)
        leak._name_site_2 = Leak.validateValue(data.site_2_name, null)
        leak._km = Leak.validateValue(data.km, 0)
        leak._lat = Leak.validateValue(data.lat, 0)
        leak._lon = Leak.validateValue(data.lon, 0)
        leak._detection_timestamp = Leak.validateValue(data.detection_timestamp, null)
        leak._timestamp = Leak.validateValue(data.timestamp, null)
        leak._status = Utils.isNumber(data.status) ? Number(data.status) : -1
        leak._type = Leak.validateValue(data.type, 0)
        leak._n_lat = Leak.validateValue(data.n_lat, 0)
        leak._n_lon = Leak.validateValue(data.n_lon, 0)
        leak._pressure_2 = Leak.validateValue(data.pressure_2, 0)
        leak._pressure_1 = Leak.validateValue(data.pressure_1, 0)
        leak._state_1 = Leak.validateValue(data.state_1, null)
        leak._state_2 = Leak.validateValue(data.state_2, null)
        leak._city_1 = Leak.validateValue(data.city_1, null)
        leak._city_2 = Leak.validateValue(data.city_2, null)
        leak._offline_status = Leak.validateValue(data.offline_status, null)
        leak._is_operational_movement = Leak.validateValue(data.is_operational_movement, null)

        // "rtu_timestamp":"2017-11-23T04:46:03.000Z","rtu_pressure":8.87,"rtu_flow":0,"rtu_battery":13,"rtu_site_door":1,"rtu_cabinet_door":0,"rtu_leak":0,"rtu_gps":1,"formated_date":"2017-11-22 22:46:03"
        return leak
    }

     static validateValue(value, defaultValue) {
        return value !== undefined && value !== null ? value : defaultValue;
      }

    get id () {
        return this._id
    }

    get btwn () {
        return this._btwn
    }

    get section1Name () {
        return this._name_section_1
    }

    get site1Name () {
        return this._name_site_1
    }

    get section2Name () {
        return this._name_section_2
    }

    get site2Name () {
        return this._name_site_2
    }

    get formattedSectionName () {
        return this.isSameSection()
        ? this.section1Name
        : this.section1Name + '/' + this.section2Name
    }

    get formattedSiteName () {
        return this.site1Name + '/' + this.site2Name
    }

    isSameSection () {
        return this._id_section_1 === this._id_section_2
    }

    get km () {
        return this._km
    }

    get lat () {
        return this._n_lat || this._lat
    }

    get lon () {
        return this._n_lon || this._lon
    }

    get formattedCoord() {
        return `${this._lat}, ${this._lon}`
    }

    get detectionTimestamp () {
        return this._detection_timestamp
    }

    get formattedDetectionTimestamp () {
        return this._detection_timestamp && this._detection_timestamp.replace('Z', '').replace('T', ' ') || ''
    }

    get status () {
        return this._status
    }

    set status (status) {
        this._status = status
    }

    get timestamp () {
        return this._timestamp
    }

    get type () {
      return this._type
  }

  get pressure_1 () {
    return this._pressure_1
  }

  get pressure_2 () {
    return this._pressure_2
  }

  get state_1 () {
    return this._state_1
  }

  get state_2 () {
    return this._state_2
  }
  
  get city_1 () {
    return this._city_1
  }

  get city_2 () {
    return this._city_2
  }

  get offline_status () {
    return this._offline_status
  }

  get is_operational_movement () {
    return this._is_operational_movement
  }

  get description () {
    var desc = 'Ducto: ';
    desc += this.isSameSection()
    ? this.section1Name
    : this.section1Name + '/' + this.section2Name;

    desc += '  ';
    desc += this.state_1 === this.state_2 ? 'Estado: ' + this.state_1 : 'Estados : ' + this.state_1 + '/' + this.state_2;
    desc += '  ';
    desc += this.city_1 === this.city_2 ? 'Ciudad: ' + this.city_1 : 'Ciudades : ' + this.city_1 + '/' + this.city_2;
    
    return desc;
}

get states () {
    return this.state_1 === this.state_2 ? this.state_1 : this.state_1 + '/' + this.state_2;
}

get cities () {
    return this.city_1 === this.city_2 ? this.city_1 : this.city_1 + '/' + this.city_2;
}

}

Leak.Status = {
    PROCESSED: -1,
    NEW: 0,
    SYSTEM_IDENTIFIED: 1,
    RECOGNIZED: 2,
    IN_DAILY_REPORT: 3,
}



// WEBPACK FOOTER //
// ./src/models/leak.js